import Clipboard from 'clipboard'

$ ->
# enable chosen js
  $('.database-chosen-select').chosen
    allow_single_deselect: true
#    no_results_text: I18n.t('application.no_databases_matched')
#    placeholder_text: I18n.t('application.choose_some_databases')

  assign_single_database_chosen_select()

  assign_application_distribution_permission_recipients_chosen_select()

  assign_datepickers()

  assign_click_to_cocoon_buttons target for target in ['budget_file', 'statement_file', 'variable_list']

  $('form.simple_form.edit_application').on('cocoon:after-insert', (e,item) ->
    assign_datepickers(item)
    assign_single_database_chosen_select(item)
  )

  $('a[data-popup]').click (e) ->
    window.open $(this).attr 'href'
    e.preventDefault()

  assign_clickable_row_actions()

  clipboard = new Clipboard('.clipboard-btn');
  clipboard.on('success', (e) ->
    e.clearSelection())

window.file_on_change = (input) ->
  input = $(input)
  text_input = input.parents("div.input-group").find("input.form-control")
  numFiles = 1
  if input.get(0).files
    input.get(0).files.length
  label = input.val().replace(/\\/g, '/').replace(/.*\//, '')
  text_input.val(label) if label

assign_datepickers = (target = 'body') ->
  $(target).find('div.datepicker').data({behaviour: "datepicker"}).datepicker({
#    format: I18n.t('date.formats.datepicker'),
#    months: I18n.t('date.month_names').slice(1),
    autoclose: true,
#    language: I18n.locale,
#    locale: I18n.locale,
    weekStart: 1
  })

  date = new Date()
  date.setFullYear(date.getFullYear() - 10)

  $(target).find('div.datepicker-early').data({behaviour: "datepicker"}).datepicker({
#    format: I18n.t('date.formats.datepicker'),
#    months: I18n.t('date.month_names').slice(1),
    autoclose: true,
#    language: I18n.locale,
#    locale: I18n.locale,
    weekStart: 1,
    defaultViewDate: {year: date.getFullYear(), month: (date.getMonth() - 1), day: date.getDate()}
  })

assign_click_to_cocoon_buttons = (target) ->
  $(".#{target}").on('cocoon:after-insert', ->
    check_to_hide_or_show_add_link(target)
  )
  $(".#{target}").on('cocoon:after-remove', ->
    check_to_hide_or_show_add_link(target)
  )

check_to_hide_or_show_add_link = (target) ->
  if ($(".#{target} .nested-fields:visible").length == 8)
    $(".#{target} .links a").hide()
  else
    $(".#{target} .links a").show()



assign_single_database_chosen_select = (target = 'body') ->
  $(target).find('.single-database-chosen-select').chosen
#    no_results_text:  I18n.t('application.no_database_matched')
#    placeholder_text:  I18n.t('application.choose_database')

assign_application_distribution_permission_recipients_chosen_select = (target = 'body') ->
  $(target).find('.application-distribution-permission-recipients-chosen-select').chosen
  #TODO: I18n on result and placeholder texts.
#    no_results_text:  I18n.t('distribution_permission.steering_group_member_field_no_search')
#    placeholder_text: I18n.t('distribution_permission.steering_group_member_field_default')


assign_clickable_row_actions = () ->
  console.log('CLICKED ROW')
  $(".clickable-row > td:not(.no-click)").off("click").click ->
    window.document.location = $(this).parent().data("href")

window.assign_clickable_row_actions = assign_clickable_row_actions


